import { dispatch } from "./Helpers/eventHelper";

export const Gender = {
    gender: "men",
    init() {
        this.initialGender();
    },
    initialGender() {
        if (window.location.pathname.match("women") || localStorage.getItem("LUC_Gender") === "women") {
            this.setGender("women");
        } else {
            this.setGender("men");
        }
    },
    persistGender() {
        localStorage.setItem("LUC_Gender", this.gender);
    },
    getGender() {
        return this.gender;
    },
    setGender(gender) {
        this.gender = gender;
        dispatch("gender-changed");
        this.persistGender();
    },
};
